import { Card, CardContent, CardHeader, Divider, Grid } from "@mui/material";
import RHFRadioGroup from "components/minimal/hook-form/rhf-radio-group";
import RHFTextValue from "components/minimal/hook-form/rhf-text-value";
import { IFormProps } from "types/form-props";
import { fDate } from "utils/format-time";
import { RADIO_Status_OPTIONS } from "./user-report-column";

interface UserReportFormProps extends IFormProps {}

const UserReportForm: React.FC<UserReportFormProps> = ({
  currentItem,
  formOperation,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="User Report Information" />
          <Divider />
          <CardContent>
            <RHFTextValue label="User" value={currentItem?.user?.fullName} />

            <RHFTextValue
              label="User Type"
              value={currentItem?.user?.userType?.label}
            />

            {currentItem?.reportUser?.blocked &&
              currentItem?.reportUser?.isActive && (
                <p style={{ color: "red", fontWeight: "bold" }}>
                  Reporter isBlocked
                </p>
              )}
            {!currentItem?.reportUser?.isActive && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Reporter isDeleted
              </p>
            )}

            <RHFTextValue
              label="Reporter User"
              value={currentItem?.reportUser?.fullName}
            />
            <RHFTextValue
              label="Reporter type"
              value={currentItem?.reporterType}
            />
            <RHFTextValue
              label="Report Date"
              value={fDate(currentItem?.reportUser?.createdAt)}
            />
            <RHFTextValue
              label="Last Updated Story"
              value={fDate(currentItem?.createdAt)}
            />
            <RHFTextValue label="Reason" value={currentItem?.reason} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <RHFRadioGroup
          label="Status"
          name="status"
          options={RADIO_Status_OPTIONS()}
          sx={{ display: "flex", flexDirection: "row" }}
          disabled={currentItem?.status === "APPROVED"}
        />
      </Grid>
    </>
  );
};

export default UserReportForm;
